import React from "react"
import "./banner.css"

const Banner = ({ image }) => {
  return (
    <div
      className="banner-wrapper"
      style={{ backgroundImage: `url(${image})`, backgroundPosition: 'center', backgroundSize: 'cover'}}
    ></div>
  )
}

export default Banner
